
import FETCHING from "../library/fetching";
import UMUM from "../library/umum";

export default {
  data() {
    return {
      leftDrawerOpen: true,
      nama: '',
      unit_kerja_nama: '',

      list_data: [],
      FETCHING: FETCHING,
      UMUM: UMUM,
    };
  },

  computed: {
    isAuthorizedApproval() {
      try {
        if (!localStorage.profile) return false;
        const profilex = JSON.parse(localStorage.profile);
        const profile = profilex.profile;
        const menuKlpId = parseInt(profile.aurel_new);
        // Role Group ID 4 = Administrator, 16 = Admin Inspektorat
        return menuKlpId === 4 || menuKlpId === 16;
      } catch (e) {
        return false;
      }
    }
  },

  methods: {
    logout: function () {
      localStorage.removeItem('token');
      localStorage.removeItem('profile');
      this.$router.push('/login');
    },

    checkLength(data) {
      if (data.length <= 0) {
        return false
      } else {
        return true
      }
    },

    checkOtorisasi() {
      fetch(this.$store.state.url.checkAuth, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          if (res_data.message == 'SSILAHKAN LOGIN DULU..!!!') {
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            this.$router.push('/login');
          } else {
            return false
          }
        });
    },

    async loadMenu() {
      var get_profile = JSON.parse(localStorage.profile);
      var profileku = get_profile.profile;
      var dataMenu = await this.FETCHING.postMasterMenuGetSideBar(profileku.aurel_new)

      this.$store.state.list_menu = dataMenu

      var data = []
      dataMenu.forEach(h => {
        if (h.type == 0) {
          data.push(h)
        } else {
          h.subItem.forEach(i => {
            if (i.type == 0) {
              data.push(i)
            } else {
              i.subItem.forEach(j => {
                data.push(j)
              });
            }
          });
        }
      });

      var obj = UMUM.ArrToObj(data)
      this.$store.state.aksesMenu = obj
    },
  },

  mounted() {
    this.checkOtorisasi();
    var get_profile = JSON.parse(localStorage.profile);
    this.nama = get_profile.profile.nama;
    this.unit_kerja_nama = get_profile.profile.unit_kerja_nama;

    this.loadMenu();
  },
};
